import * as types from './StoreActionTypes';
import firebaseApp from '../../utils/firebase/firebase';

import SingletonLibrary from '../../library/SingletonLibrary';

const pushProducts = (products, total, loadedPage) => {
    return {
        type : types.GET_PRODUCTS,
        products,
        total,
        loadedPage
    }
}

const setStoreFail = (errorMessage, errorCode, errorType) => {
    return {
        type : types.ERROR_PRODUCTS,
        errorMessage,
        errorCode,
        errorType
    }
}

export const setStorePosition = ( targetedProduct ) => {
    return ( dispatch ) => {
        dispatch({
            type : types.SET_POSTION_PRODUCTS,
            targetedProduct
        });
    }
}

export const resetStore = () => {
  return ( dispatch ) => {
    dispatch({
      type : types.RESET_PRODUCT_LIST
  });
  }
}

export const getProductByPage = (page) => {
    return (dispatch, getState) => {
        //-- If Page is not already retrieved
        if ( getState().datasStore.loadedPage < page && firebaseApp.auth().currentUser !== null ) {

            firebaseApp.auth().currentUser.getIdToken()
                .then((fbIdToken) => {
                    return SingletonLibrary
                            .getAxiosInstance
                            .get('/store/products', { 'headers':{'fbkm-access-token':fbIdToken}, 'params': { 'p': page} });
                            
                })
                .then((result) => {
                    const response = ( result.error !== true && typeof result.data.response !== 'undefined' )?  
                        result.data.response : null ;
                    
                    if( response !== null ) {
                        dispatch(pushProducts(response.products, response.total, page));
                    }
                })
                .catch((e) => {
                    const errorCode =  ( typeof e.response !== 'undefined' && e.response.status ) || 0;
                    const errorMessage = ( typeof e.response !== 'undefined' && e.response.statusText ) || 'Erreur inattendue';
                
                    dispatch(setStoreFail(errorMessage, errorCode, "error")); 
                });  
        }
    };
    
}


// WEBPACK FOOTER //
// ./src/components/StorePage/StoreActions.js